import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useRef } from 'react';
import { useOption } from 'react-aria';
import clsx from 'clsx';
import { CheckIcon } from '../../../icons/CheckIcon.js';
import styles from './Item.module.scss.js';

var Item = forwardRef(function (_a, ref) {
    var _b;
    var state = _a.state, item = _a.item, children = _a.children, className = _a.className, hideCheckIcon = _a.hideCheckIcon;
    var localRef = useRef(null);
    var liRef = ref || localRef;
    var _c = useOption({
        key: item.key,
    }, state, liRef), optionProps = _c.optionProps, isSelected = _c.isSelected, isFocused = _c.isFocused, isDisabled = _c.isDisabled;
    return (jsxs("li", __assign({ className: clsx(styles.item, className, item.props.className, (_b = {},
            _b[styles.itemFocused] = isFocused,
            _b[styles.itemDisabled] = isDisabled,
            _b)) }, optionProps, { ref: liRef }, { children: [jsx("span", __assign({ "aria-hidden": "true" }, { children: item.props.icon })), children, !hideCheckIcon && isSelected && (jsx("span", __assign({ "aria-hidden": "true" }, { children: jsx(CheckIcon, { className: clsx(styles.itemIcon) }) })))] })));
});

export { Item };
